import { render, staticRenderFns } from "./SentimentCat.vue?vue&type=template&id=33dbcf40&scoped=true"
import script from "./SentimentCat.vue?vue&type=script&lang=js"
export * from "./SentimentCat.vue?vue&type=script&lang=js"
import style0 from "./SentimentCat.vue?vue&type=style&index=0&id=33dbcf40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dbcf40",
  null
  
)

export default component.exports